export default "__VITE_PUBLIC_ASSET__f4ea3975__"